import MessengerIcon from '../assets/social/messenger.png';
import FacebookIcon from '../assets/social/fb.png';
import InstagramIcon from '../assets/social/instagram.png';
import LineIcon from '../assets/social/line.png';
import TelegramIcon from '../assets/social/telegram.png';
import TwitterIcon from '../assets/social/twitter.png';
import ViberIcon from '../assets/social/viber.png';
import WeChatIcon from '../assets/social/wechat.png';
import WhatsAppIcon from '../assets/social/wa.png';
import YouTubeIcon from '../assets/social/yt.png';
import PinterestIcon from '../assets/social/pinterest.png';
import LiveChatIcon from '../assets/social/live-chat.png';
import { useDispatch, useSelector } from '../redux/store';

export const getSocialLinks = (siteConfigs) => {
  if (!siteConfigs) return [];

  const data = [
    {
      id: 1,
      name: 'Telegram',
      type: 'telegram',
      icon: TelegramIcon,
      url: siteConfigs?.config_telegram,
    },
    {
      id: 2,
      name: 'telegram_channel',
      type: 'telegram',
      icon: TelegramIcon,
      url: siteConfigs?.config_telegram_channel,
    },
    {
      id: 3,
      name: 'WhatsApp',
      type: 'whatsapp',
      icon: WhatsAppIcon,
      url: siteConfigs?.config_whatsapp,
    },
    {
      id: 4,
      name: 'WhatsApp',
      type: 'whatsapp',
      icon: WhatsAppIcon,
      url: siteConfigs?.config_whatsapp2,
    },
    {
      id: 5,
      name: 'WeChat',
      type: 'other',
      icon: WeChatIcon,
      url: siteConfigs?.config_wechat,
    },
    {
      id: 6,
      name: 'Facebook',
      type: 'other',
      icon: FacebookIcon,
      url: siteConfigs?.config_facebook,
    },
    {
      id: 7,
      name: 'Messenger',
      type: 'other',
      icon: MessengerIcon,
      url: siteConfigs?.config_messenger,
    },
    {
      id: 8,
      name: 'Instagram',
      type: 'other',
      icon: InstagramIcon,
      url: siteConfigs?.config_instagram,
    },
    {
      id: 9,
      name: 'YouTube',
      type: 'other',
      icon: YouTubeIcon,
      url: siteConfigs?.config_youtube,
    },
    {
      id: 10,
      name: 'LINE',
      type: 'other',
      icon: LineIcon,
      url: siteConfigs?.config_line,
    },
    {
      id: 11,
      name: 'Twitter',
      type: 'other',
      icon: TwitterIcon,
      url: siteConfigs?.config_twitter,
    },
    {
      id: 12,
      name: 'Viber',
      type: 'other',
      icon: ViberIcon,
      url: siteConfigs?.config_viber,
    },
    {
      id: 13,
      name: 'Pinterest',
      type: 'other',
      icon: PinterestIcon,
      url: siteConfigs?.config_pinterest,
    },
    {
      id: 14,
      name: 'Live Chat',
      type: 'livechat',
      icon: LiveChatIcon,
      url: siteConfigs?.config_livechat,
    },
  ];
  return data;
};
